const Company = {

    // FIELDS
    "company": "Company",
    "name": "Name",
    "logo": "Logo",
    "description": "Description",
    "email": "Email",
    "phone": "Phone",
    "address": "Address",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Company",
    "filter_title": "Company Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_logo": "Logo",
    "table_email": "Email",
    "table_phone": "Phone",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Company Name",
    "error_logo": "Select Logo",
    "error_description": "Enter Description",
    "error_email": "Enter Email",
    "error_phone": "Enter Phone",
    "error_address": "Enter Address",
    "error_status": "Select Status",

}

export default Company;

